import { render } from "./PublicationList.vue?vue&type=template&id=11191e68"
import script from "./PublicationList.vue?vue&type=script&lang=ts"
export * from "./PublicationList.vue?vue&type=script&lang=ts"
script.render = render

export default script